import type { ReactNode } from 'react';

import { Button } from 'braid-design-system';

import { useCreateSavedSearch } from 'src/modules/hooks/SavedSearch';
import { SAVE_SEARCH_BEGIN } from 'src/store/saveSearch/saveSearch';
import { useDispatch } from 'src/store/react';
import type { ButtonSize } from 'src/types/globals';

export interface SaveSearchButtonProps {
  children: ReactNode;
  size?: ButtonSize;
  loading?: boolean;
  dataAutomation?: string;
}

const SaveSearchButton = (props: SaveSearchButtonProps) => {
  const dispatch = useDispatch();
  const saveSearch = useCreateSavedSearch();

  const createSavedSearch = () => {
    dispatch({
      type: SAVE_SEARCH_BEGIN,
      meta: { hotjar: 'Saved Search' },
    });
    saveSearch();
  };

  const buttonProps = {
    children: props.children,
    size: props.size,
    loading: props.loading,
  };
  return (
    <Button
      {...buttonProps}
      data={{ automation: props.dataAutomation || '' }}
      onClick={createSavedSearch}
      tone="formAccent"
    />
  );
};

export default SaveSearchButton;
